module.exports = __webpack_public_path__ + "img/title-1.ad463a75.png";